export default "__VITE_ASSET__8048e964__"